function parseIetfLanguageTag(tag) {
  if (typeof tag !== 'string') {
    return {
      language: undefined,
      country: undefined
    };
  }
  const result = /([a-z]{2,})-?([a-zA-Z]{2,})?/.exec(tag);
  if (!result) {
    return {
      language: undefined,
      country: undefined
    };
  }
  const [, language, country] = result;
  return {
    language,
    country
  };
}

export { parseIetfLanguageTag as p };
//# sourceMappingURL=parseIetfLanguageTag-edc8174b.js.map
